
import React from "react";
import { useRelatedNursingHomes } from "@/hooks/use-related-nursing-homes";
import { NursingHomeCard } from "./NursingHomeCard";
import { SectionHeader } from "@/components/ui/section-header";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface RelatedNursingHomesProps {
  currentNhSlug: string;
  countySlug: string;
  countyName: string;
}

export function RelatedNursingHomes({ 
  currentNhSlug, 
  countySlug,
  countyName 
}: RelatedNursingHomesProps) {
  const { data: relatedHomes, isLoading, error } = useRelatedNursingHomes(
    currentNhSlug,
    countySlug,
    3
  );

  if (isLoading) {
    return (
      <div className="w-full space-y-4 mt-10">
        <h2 className="text-xl font-semibold text-center">More Nursing Homes in {countyName}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 container mx-auto px-0">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-80 bg-gray-100 animate-pulse rounded-lg"></div>
          ))}
        </div>
      </div>
    );
  }

  if (error || !relatedHomes || relatedHomes.length === 0) {
    return null;
  }

  return (
    <div className="w-full space-y-8 mt-10">
      <SectionHeader 
        title={`More Nursing Homes in ${countyName}`}
        subtitle="Explore other care options in this area"
        centered={true}
      />
      
      <div className="container mx-auto px-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {relatedHomes.map((home) => (
            <div key={home.nh_slug}>
              <NursingHomeCard 
                nursingHome={home} 
                hideBorder={false}
                size="md"
              />
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-center mt-8">
        <Link to={`/nursing-homes/${countySlug}`}>
          <Button className="flex items-center gap-2">
            View all nursing homes in {countyName}
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
